<div class="filters-box" [formGroup]="filters">
  <app-rental-select
    i18n-matTooltip
    i18n-placeholder
    matTooltip="Only show discounts that specify the selected rentals."
    [ctrl]="filters.get('rentals')"
    placeholder="Rentals"
    [inline]="true"
    *ngIf="!rental?.id"
  ></app-rental-select>
  <mat-form-field2 class="field-categories" [showLabel]="false">
    <mat-select
      formControlName="discountType"
      placeholder="Discount Type"
      i18n-placeholder
      matTooltip="Only show discounts that specify the selected discount type."
      matTooltipPosition="above"
      i18n-matTooltip
    >
      <mat-option [value]="" i18n>All</mat-option>
      <mat-option value="los" i18n>LOS Discount</mat-option>
      <mat-option value="code" i18n>Discount Code</mat-option>
    </mat-select>
  </mat-form-field2>
  <mat-form-field2 class="field-categories" [showLabel]="false">
    <mat-select
      formControlName="type"
      placeholder="Type"
      i18n-placeholder
      matTooltip="Only show discounts that specify the selected type."
      matTooltipPosition="above"
      i18n-matTooltip
    >
      <mat-option [value]="" i18n>All</mat-option>
      <mat-option value="flat" i18n>Flat</mat-option>
      <mat-option value="pct" i18n>Percent</mat-option>
    </mat-select>
  </mat-form-field2>

  <app-cancel-filters
    [filterControl]="filters"
    [isFiltering]="filters | isFiltering : (rental ? ['rentals'] : [])"
    [ignoreFields]="rental ? ['rentals'] : []"
    [searchCom]="search"
  ></app-cancel-filters>
  <button
    class="btn btn-secondary-primary"
    (click)="onRefresh()"
    matTooltip="Refresh List"
    matTooltipPosition="above"
    i18n-matTooltip
  >
    <i class="far fa-sync"></i>
  </button>

  <div class="flex-fill"></div>
  <app-table-search
    (search)="onSearch($event)"
    #search
    matTooltip="Search by name, type or amount."
    matTooltipPosition="above"
    i18n-matTooltip
  ></app-table-search>
  <div class="btn-group" *ngIf="showAddBtn" dropdown [isDisabled]="1 | isReadonlyRole">
    <button type="button" class="btn btn-secondary-info dropdown-toggle" dropdownToggle>
      <span class="far fa-plus"></span> <ng-container i18n>Add Discount</ng-container>
    </button>
    <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
      <li>
        <button type="button" (click)="onAddLosDiscount()">
          <i class="cs-icon cs-icon-los-discount fa-fw"></i>
          <ng-container i18n>LOS Discount</ng-container>
        </button>
      </li>
      <li>
        <button type="button" (click)="onAddDiscountCode()">
          <i class="cs-icon cs-icon-discount-code fa-fw text-xs"></i>
          <ng-container i18n>Discount Code</ng-container>
        </button>
      </li>
    </ul>
  </div>
</div>

<div class="table-holder table-responsive">
  <table class="table table-default table-striped">
    <mat-table #table matSort matSortActive="channelName" matSortDirection="asc" [dataSource]="dataSource">
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          >
          </mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
          >
          </mat-checkbox>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="text-truncate">{{ element.name }}</div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="discountTypeView">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Discount Type</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.discountTypeView }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Type</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <ng-container i18n *ngIf="element.type === 'pct'">Percent</ng-container>
          <ng-container i18n *ngIf="element.type !== 'pct'">Flat</ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="amount">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Amount</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.type === 'pct' ? element.amount + '%' : (element.amount | number : '.2-2') }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="startView">
        <mat-header-cell *matHeaderCellDef mat-sort-header="start" i18n>Start</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.startView }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="endView">
        <mat-header-cell *matHeaderCellDef mat-sort-header="end" i18n>End</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.endView }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef i18n>Edit</mat-header-cell>

        <mat-cell *matCellDef="let element">
          <div dropdown placement="bottom right" container="body" [isDisabled]="1 | isReadonlyRole">
            <div dropdownToggle (click)="$event.stopPropagation()" class="btn-group btn-ellips-holder">
              <a class="btn-ellips" matTooltip="You can perform multiple actions using this button" i18n-matTooltip>
                <i class="fas fa-ellipsis-v"></i>
              </a>
            </div>
            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
              <li *ngIf="element.discountType === 'los'">
                <button (click)="onEdit(element)" type="button">
                  <i class="fal fa-file-alt"></i> <ng-container i18n>View</ng-container>
                </button>
              </li>
              <li *ngIf="element.discountType === 'code'">
                <button
                  (click)="onEdit(element)"
                  type="button"
                  matTooltip="Edit this Discount"
                  matTooltipPosition="left"
                  i18n-matTooltip
                >
                  <i class="fal fa-edit"></i> <ng-container i18n>Edit</ng-container>
                </button>
              </li>
              <li *ngIf="element.discountType === 'los'">
                <button
                  (click)="onDelete(element)"
                  type="button"
                  matTooltip="Delete this Discount"
                  matTooltipPosition="left"
                  i18n-matTooltip
                >
                  <i class="cs-icon cs-icon-trash"></i><ng-container i18n>Delete</ng-container>
                </button>
              </li>
              <li
                *ngIf="element.discountType === 'code'"
                [matTooltip]="
                  element.isUsed
                    ? 'Used Discount Code can not be deleted. You can deactivate this code if you do not want to use it anymore'
                    : ''
                "
                matTooltipPosition="left"
              >
                <button
                  (click)="onDelete(element)"
                  type="button"
                  [disabled]="element.isUsed"
                  matTooltip="Delete this Discount"
                  matTooltipPosition="left"
                  i18n-matTooltip
                >
                  <i class="cs-icon cs-icon-trash"></i><ng-container i18n>Delete</ng-container>
                </button>
              </li>
            </ul>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" (click)="onEdit(row)" class="clickable"></mat-row>
    </mat-table>

    <mat-paginator2
      #paginator
      [length]="dataSource?.data?.length"
      [class.hidden]="isEmptyTable$ | async"
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
      [showFirstLastButtons]="true"
    >
    </mat-paginator2>

    <app-empty-table *ngIf="isEmptyTable$ | async" [type]="tableType" class="bg-white"></app-empty-table>
  </table>
</div>
